export const ZEM_CHARGE_OPTION_AMOUNTS = [10, 30, 50, 100, 300, 500] as const;

const ZEM_CHARGE_OPTION_ORDER = new Map<number, number>(
  ZEM_CHARGE_OPTION_AMOUNTS.map((amount, index) => [amount, index]),
);

export const getZemChargeOptions = <T extends { addCashMoney: number }>(
  items: T[],
) =>
  items
    .filter(item => ZEM_CHARGE_OPTION_ORDER.has(item.addCashMoney))
    .sort(
      (left, right) =>
        ZEM_CHARGE_OPTION_ORDER.get(left.addCashMoney)! -
        ZEM_CHARGE_OPTION_ORDER.get(right.addCashMoney)!,
    );

export const getSelectedZemChargeOption = <T extends { addCashMoney: number }>(
  items: T[],
  selectedAmount: number,
) => items.find(item => item.addCashMoney === selectedAmount) ?? items[0];
